export const generateSyncImportItems = () => {
    const templateMenuItems = [
        {
            name: 'RSS Feeds',
            type: 'rss',
            img: 'app-rss',
            category: ['rss', 'marketing', 'import'],
            description: 'Get the main topics from multiple feeds',
            url: `/import/rss`,
        },
        {
            name: 'News Analysis',
            img: 'app-preselected',
            type: 'news',
            category: [
                'news',
                'recommended',
                'new',
                'marketing',
                'all-use-cases',
            ],
            description: 'Current news trends from multiple sources',
            url: `/import/news`,
        },
        // {
        //     name: 'Search Results',
        //     img: 'app-google-search',
        //     type: 'google',
        //     category: [
        //         'news',
        //         'recommended',
        //         'new',
        //         'marketing',
        //         'all-use-cases',
        //     ],
        //     description: 'Get an overview of any topic on Google',
        //     url: `/import/google`,
        // },
        {
            name: 'Websites & URLs',
            img: 'app-link',
            type: 'urls',
            category: [
                'urls',
                'recommended',
                'new',
                'marketing',
                'all-use-cases',
            ],
            description: 'Visualize the content of web pages',
            url: `/import/url`,
        },
        // {
        //     name: 'X (Twitter) Topics',
        //     img: 'app-x',
        //     type: 'twitter',
        //     category: [
        //         'news',
        //         'recommended',
        //         'new',
        //         'marketing',
        //         'all-use-cases',
        //     ],
        //     description: 'Search results, X lists, accounts',
        //     url: `/import/twitter`,
        // },
        {
            name: 'YouTube Videos',
            img: 'app-youtube',
            category: ['google', 'import', 'marketing', 'seo', 'all-use-cases'],
            description: 'Get a visual overview of any YouTube video',
            url: `/import/youtube-subtitles`,
        },
        {
            name: 'Evernote',
            img: 'app-evernote',
            category: ['notes', 'pkm', 'note-tools', 'import', 'all-use-cases'],
            description: 'Visualize your Evernote notes',
            url: `/import/evernote`,
        },
        {
            name: 'Obsidian (MD)',
            img: 'app-obsidian',
            category: [
                'files',
                'notes',
                'pkm',
                'popular',
                'note-tools',
                'import',
            ],
            type: 'mdFilesImport',
            description: 'Visualize your Obsidian files',
            url: `/import/markup`,
        },
        // {
        //     name: 'LogSeq',
        //     img: 'app-logseq',
        //     category: [
        //         'files',
        //         'notes',
        //         'pkm',
        //         'note-tools',
        //         'import',
        //         'all-use-cases',
        //     ],
        //     type: 'mdFilesImport',
        //     description: 'Visualize your LogSeq files',
        //     url: `/import/markup`,
        // },
        {
            name: 'Roam',
            img: 'app-roamresearch',
            category: [
                'files',
                'notes',
                'pkm',
                'note-tools',
                'import',
                'all-use-cases',
            ],
            type: 'mdFilesImport',
            description: 'Visualize your Roam Research files',
            url: `/import/markup`,
        },

        {
            name: 'Gephi (Gexf) Files',
            img: 'app-gephi',
            type: 'gexfFileImport',
            category: ['files', 'import', 'all-use-cases'],
            description: 'Import Gephi and gexf files',
            url: `/import/gexf`,
        },
        {
            name: 'JSON Files',
            img: 'app-json',
            type: 'jsonFileImport',
            category: ['files', 'import', 'all-use-cases'],
            description: 'Import JSON files',
            url: `/import/json`,
        },
    ]
    return templateMenuItems
}
